import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import React from 'react'
import FormFieldProps, { FormFieldType } from '@App/forms/v2/common/form-field'
import FormFieldFromProps from '@Fields/v2/FormFieldFromProps'
import { RightsholderMaintenanceType } from '@Entities/schemas/rightsholder/rightsholder-maintenance-schema'

interface IdentifiersSectionProps {
    hfaPublisherNumber: FormFieldType<string | undefined | null>
    ipiNumber: FormFieldType<string | undefined | null>
    isni: FormFieldType<string | undefined | null>
    rightsHolderData: Partial<RightsholderMaintenanceType>
}
const IdentifiersSection = (props: IdentifiersSectionProps) => {
    const { hfaPublisherNumber, ipiNumber, isni, rightsHolderData } = props
    return (
        <section className="identifiers-section">
            <h5>Identifiers</h5>
            <div className="fields-row-container">
                <FormFieldFromProps field={hfaPublisherNumber as FormFieldProps} isDisabled={!!hfaPublisherNumber} />
                <span className="line">
                    <FormFieldFromProps field={ipiNumber as FormFieldProps} isDisabled={!!rightsHolderData.ipiNumber} />
                    <CustomToolTip
                        type="?"
                        info={
                            'Once an IPI number has been communicated to The MLC, it cannot be updated. If you need to make a change,' +
                            ' please contact support.'
                        }
                    />
                </span>
                <FormFieldFromProps field={isni as FormFieldProps} />
            </div>
        </section>
    )
}
export default IdentifiersSection
